import { isSafeKey } from '@sit/core';
export function deepMerge(target, source) {
    const returnType = (target || {});
    for (const key in source) {
        // Prevent prototype pollution
        if (!Object.prototype.hasOwnProperty.call(source, key) || !isSafeKey(key))
            continue;
        if (source[key] instanceof Object)
            Object.assign(source[key], deepMerge(returnType[key], source[key]));
    }
    Object.assign(returnType || {}, source);
    return returnType;
}
//# sourceMappingURL=sitUtils.js.map